import { render, staticRenderFns } from "./CampaignVerificationPopup.vue?vue&type=template&id=523c22f8"
import script from "./CampaignVerificationPopup.vue?vue&type=script&lang=js"
export * from "./CampaignVerificationPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports